<script>
import modalMixin from '@phoenix/mixins/modalMixin';
import Modal from '@maison/components/common/Modal.vue';
import { PhxIcon, PhxSizeGuide } from '@phx-styleguides/jlc';

export default {
  components: {
    Modal,
    PhxIcon,
    PhxSizeGuide,
  },

  mixins: [modalMixin],

  props: {
    strapMeasuringGuideUrl: {
      type: String,
      default: null,
    },
    config: {
      type: Object,
      required: true,
    },
    i18n: {
      type: Object,
      required: true,
    },
  },
};
</script>

<template>
  <teleport to="body">
    <modal
      :id="id"
      :title="$t('FindYourFit.modal.title')"
      default
      :classes="['size-guide__modal']"
      :header-bordered="true"
    >
      <template #content>
        <phx-size-guide :i18n="i18n" :config="config">
          <template v-if="strapMeasuringGuideUrl" #how-to-measure-wrist>
            <a :href="strapMeasuringGuideUrl" class="btn btn--default btn--icon btn--link btn--sm" target="_blank">
              <span class="btn__text">{{ $t('StrapSizeFinder.form.measuring.guide.button') }}</span>
              <span class="btn__icon">
                <phx-icon icon="chevron-10" bidirectional />
              </span>
            </a>
          </template>
        </phx-size-guide>

        <slot></slot>
      </template>
    </modal>
  </teleport>
</template>
